<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>companies.sms.fraud-limit.fraud-rate-limits</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="form-container">
        <form [formGroup]="fraudRateLimitForm" (ngSubmit)="sendRequest()">
            <label class="vox-field-label d-flex align-items-center" for="accountRate">
                <span translate>companies.sms.fraud-limit.account-rate</span>
                <i class="icon-small-info ml-1"
                  [ngbTooltip]="'companies.sms.fraud-limit.popup-tooltip'| translate: {time: smsRateLimits.company_rate_limit.per_seconds}">
                </i>
            </label>
            <div class="vox-input-group mb-4" 
            [ngClass]="{'vox-input-group_invalid': accountRate.dirty && accountRate.invalid,
                        'vox-input-group_valid': accountRate.dirty && accountRate.valid}">
              <input class="vox-text-field" type="text" id="accountRate" formControlName="accountRate" />
              <i *ngIf="accountRate.invalid" class="vox-text-field__icon  icon-small-alert"></i>
              <i *ngIf="accountRate.valid" class="vox-text-field__icon  icon-small-check"></i>
              <span *ngIf="fraudRateLimitForm.get('accountRate')?.errors?.['required']" class="vox-input-group__error-message" translate>companies.sms.fraud-limit.errors.required</span>
              <span *ngIf="fraudRateLimitForm.get('accountRate')?.errors?.['pattern']" class="vox-input-group__error-message" translate>companies.sms.fraud-limit.errors.invalid</span>
              <span *ngIf="fraudRateLimitForm.get('accountRate')?.errors?.['min']" class="vox-input-group__error-message" translate>companies.sms.fraud-limit.errors.min</span>
            </div>
            <label class="vox-field-label d-flex align-items-center" for="identicalMessageRate">
              <span translate>companies.sms.fraud-limit.identical-rate</span>
              <i class="icon-small-info ml-1"
                [ngbTooltip]="'companies.sms.fraud-limit.popup-tooltip'| translate: {time: smsRateLimits.content_rate_limit.per_seconds}">
              </i>
            </label>
            <div class="vox-input-group mb-4" 
            [ngClass]="{'vox-input-group_invalid': identicalMessageRate.dirty && identicalMessageRate.invalid,
                        'vox-input-group_valid': identicalMessageRate.dirty && identicalMessageRate.valid}">
              <input class="vox-text-field" type="text" id="identicalMessageRate" formControlName="identicalMessageRate" />
              <i *ngIf="identicalMessageRate.invalid" class="vox-text-field__icon  icon-small-alert"></i>
              <i *ngIf="identicalMessageRate.valid" class="vox-text-field__icon  icon-small-check"></i>
              <span *ngIf="fraudRateLimitForm.get('identicalMessageRate')?.errors?.['required']" class="vox-input-group__error-message" translate>companies.sms.fraud-limit.errors.required</span>
              <span *ngIf="fraudRateLimitForm.get('identicalMessageRate')?.errors?.['pattern']" class="vox-input-group__error-message" translate>companies.sms.fraud-limit.errors.invalid</span>
              <span *ngIf="fraudRateLimitForm.get('identicalMessageRate')?.errors?.['min']" class="vox-input-group__error-message" translate>companies.sms.fraud-limit.errors.min</span>
            </div>
          <div class="submit-container">
            <button class="vox-btn vox-btn-primary" type="submit" [disabled]="fraudRateLimitForm.invalid || isRateLimitsUnchanged()">
              {{'companies.sms.fraud-limit.popup-btn' | translate}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>